<footer class="govbook-footer">
  <div class="govbook-footer__pre-footer">
    <div class="govuk-width-container">
      <div class="row">
        <div class="col-sm-12">
           <div
            class="govbook-region govbook-region--footer-first region region-footer-first"
          >
            <div class="govbook-container padding-horizontal">
              <div
                class="govbook-region__inner govbook-region__inner--footer-first"
              >
                <nav
                  aria-labelledby="block-ecc-theme-gov-footer-menu"
                  id="block-ecc-theme-gov-footer"
                  class="block block-menu navigation navigation--footer"
                >
                  <h2
                    class="visually-hidden"
                    id="block-ecc-theme-gov-footer-menu"
                  >
                    Footer
                  </h2>

                  <ul class="menu menu--footer">
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="Contact us (opens in new window)"
                        rel="noopener noreferrer"
                        class="footer-links"
                        href="https://www.havering.gov.uk/contactus"
                        data-drupal-link-system-path="node/1004"
                        >Contact us</a
                      >
                    </li>
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="Cookies (opens in new window)"
                        rel="noopener noreferrer"
                        class="footer-links"
                        href="https://www.havering.gov.uk/council-democracy/cookies"
                        data-drupal-link-system-path="node/954"
                        >Cookies</a
                      >
                    </li>
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="Accessibility statement (opens in new window)"
                        rel="noopener noreferrer"
                        class="footer-links"
                        [routerLink]="['/accessibility-statement']"
                        >Accessibility</a
                      >
                    </li>
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="Privacy and data protection (opens in new window)"
                        rel="noopener noreferrer"
                        class="footer-links"
                        href="https://www.havering.gov.uk/privacynotice"
                        data-drupal-link-system-path="node/940"
                        >Privacy and data protection</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>

          <div
            class="govbook-region govbook-region--footer-third region region-footer-third"
          >
            <div class="govbook-container padding-horizontal">
              <div
                class="govbook-region__inner govbook-region__inner--footer-third"
              >
                <nav
                  aria-labelledby="block-ecc-theme-gov-socialmedia-menu"
                  id="block-ecc-theme-gov-socialmedia"
                  class="block block-menu navigation navigation--social-media"
                >
                  <h2
                    class="visually-hidden"
                    id="block-ecc-theme-gov-socialmedia-menu"
                  >
                    Social Media
                  </h2>

                  <ul class="menu menu--social-media">
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="Facebook (opens in new window)"
                        class="footer-links"
                        href="https://www.facebook.com/LBofHavering/"
                        class="social-link facebook"
                        >Facebook</a
                      >
                    </li>
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="X, formerly Twitter (opens in new window)"
                        class="footer-links"
                        href="https://twitter.com/LBofHavering"
                        class="social-link twitter"
                        >X (formerly Twitter)</a
                      >
                    </li>
                    <li class="menu-item">
                      <a
                        target="_blank"
                        aria-label="Instagram (opens in new window)"
                        class="footer-links"
                        href="https://www.instagram.com/lbofhavering/"
                        class="social-link instagram"
                        >Instagram</a
                      >
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="govbook-footer__footer">
    <div class="govbook-container">
      <div class="govbook-row">
        <div class="govbook-row__full">
          <div
            class="govbook-region govbook-region--footer region region-footer"
          >
            <div class="govbook-container padding-horizontal">
              <div class="govbook-region__inner govbook-region__inner--footer">
                <div
                  id="block-ecc-theme-gov-localgov-poweredbylocalgovdrupal-scarfolk"
                  class="block block-localgov-core block-localgov-powered-by-block"
                >
                  <span
                    >Powered by
                    <a
                      target="_blank"
                      aria-label="Bookinglab | GovBook (opens in new window)"
                      class="footer-links"
                      href="https://www.bookinglab.co.uk/solutions/gov-book/registrars-and-ceremonies-booking-system/?utm_source=clientbrowser&utm_medium=clientbookingjourney&utm_campaign=registrarsbooking&utm_content=ecc
                                            "
                      >bookinglab | GovBook</a
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
